/** Shared width for the "Título" column across all collection tables. */
export const COLLECTION_TITLE_COLUMN_WIDTH = 200;

/** Wider metrics: Views, Likes. */
export const COLLECTION_METRIC_COLUMN_WIDTH = 110;

/** Narrower metrics: COMENT., demography, … */
export const COLLECTION_METRIC_NARROW_COLUMN_WIDTH = 90;

/** Fixed width for the actions / Ver column across all collection tables. */
export const COLLECTION_DETALLES_COLUMN_WIDTH = 100;

/** Short header for comments column; full word in tooltip. */
export const COLLECTION_COMMENTS_COLUMN_LABEL = "Comen.";
export const COLLECTION_COMMENTS_COLUMN_TOOLTIP = "Comentarios";

/** Posición column (between narrow metric and former 2× width). */
export const COLLECTION_POSICION_COLUMN_WIDTH = 140;

/** Fixed widths for identity columns (left-aligned). */
/** Platform icon + short type label (text already capped ~72px). */
export const COLLECTION_TIPO_COLUMN_WIDTH = 108;
/** Match Tipo — short date text (e.g. DD/MM/YY). */
export const COLLECTION_FECHA_COLUMN_WIDTH = COLLECTION_TIPO_COLUMN_WIDTH;

/** Platform stats tables: metric col width (narrow × 1.1³ ≈ 120). */
export const COLLECTION_PLATFORM_METRIC_COLUMN_WIDTH = Math.round(
  COLLECTION_METRIC_NARROW_COLUMN_WIDTH * 1.1 * 1.1 * 1.1,
);

/** Platform stats Tipo floor — compact; metrics keep the wider fixed width. */
export const COLLECTION_PLATFORM_TIPO_COLUMN_WIDTH = 100;

/** Placement column in RRSS presence table (between tipo and former 2× width). */
export const COLLECTION_PLACEMENT_COLUMN_WIDTH = 180;

/** Optional "Cuenta" column in multi-channel collections (avatar + handle). */
export const COLLECTION_ACCOUNT_COLUMN_WIDTH = 124;

/** Clips reports: avatar-only Cuenta column. */
export const COLLECTION_ACCOUNT_AVATAR_COLUMN_WIDTH = 72;

/** Thumbnail-only (40px) + cell padding. */
export const COLLECTION_IMAGEN_COLUMN_WIDTH = 88;
/** Brand logo-only (32px) + cell padding. */
export const COLLECTION_MARCA_COLUMN_WIDTH = 80;
